export const TOGGLE = 'TOGGLE_SIDEBAR'
